export default "__VITE_ASSET__DRzvW7TY__"